import { FC } from "react";
import { Box, Typography } from "@material-ui/core";
import { shallowEqual } from "react-redux";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { useShiftPageStyles } from "../styles";

const getDaStatusCounts = (rows: { da_status: number }[]) => {
  const counts = { total: rows.length, pending: 0, confirmed: 0, rejected: 0, cancelled: 0 };

  for (const row of rows) {
    if (row.da_status === 0) counts.pending += 1;
    else if (row.da_status === 1) counts.confirmed += 1;
    else if (row.da_status === 2) counts.rejected += 1;
    else if (row.da_status === 3) counts.cancelled += 1;
  }

  return counts;
};

const FOOTER_STATS: { key: keyof ReturnType<typeof getDaStatusCounts>; label: string }[] = [
  { key: "total", label: "Total DA:" },
  { key: "pending", label: "Pending:" },
  { key: "confirmed", label: "Confirmed:" },
  { key: "rejected", label: "Rejected:" },
  { key: "cancelled", label: "Cancelled:" },
];

const ShiftRecordTableFooter: FC = () => {
  const classes = useShiftPageStyles();
  const counts = useTypeSelectors(
    (state) => getDaStatusCounts(state.dasBoard.currentReport),
    shallowEqual,
  );

  return (
    <Box className={classes.tableFooter}>
      {FOOTER_STATS.map((item) => (
        <Box key={item.key} className={classes.footerStatsBox}>
          <Typography>{item.label}</Typography>
          <Typography style={{ fontWeight: 600 }}>{counts[item.key]}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default ShiftRecordTableFooter;
